// src/pages/Home.js
import React from "react";
import "../App.css";

function HomePage() {
  return (
    <div style={{ padding: "2rem" }}>
      <section className="hero">
        <h1>Order Your First Custom AI Chatbot NOW!</h1>
        <p>Let us handle repetitive customer inquiries and leave your team to focus on higher-value tasks!</p>
        <p className="highlight"><b>Each chatbot can save between 40 to 70 staff hours per month — that's up to 50% of a full-time employee’s workload in a year!</b></p>
      </section>

      <section className="demo-images">
        <h2>Gallery</h2>
        <div className="demo-grid">
          <img src={`${process.env.PUBLIC_URL}/demo1.png`} alt="Demo 1" />
          <img src={`${process.env.PUBLIC_URL}/demo2.png`} alt="Demo 2" />
          <img src={`${process.env.PUBLIC_URL}/demo3.png`} alt="Demo 3" />
        </div>
        <p className="demo-note">These are a few sample screenshots of our FAQ chatbots. Live demo coming soon!</p>
      </section>
    </div>
  );
}

export default HomePage;